/**
 * Processing event and session type enums for the warehouse returns
 * processing domain. These are the source of truth — the RPC schema
 * and DB schema both import from here.
 */

export const processingEventTypes = [
  "session_started",
  "session_completed",
  "session_timeout",
  "session_abandoned",
  "session_item_started",
  "session_item_completed",
  "session_item_timeout",
  "processing_step_started",
  "processing_step_completed",
  "evidence_added",
  "agent_evaluation_completed",
  "unboxing_video_captured",
] as const;

export type ProcessingEventType = (typeof processingEventTypes)[number];

export const ProcessingEventType = {
  SESSION_STARTED: "session_started",
  SESSION_COMPLETED: "session_completed",
  SESSION_TIMEOUT: "session_timeout",
  SESSION_ABANDONED: "session_abandoned",
  SESSION_ITEM_STARTED: "session_item_started",
  SESSION_ITEM_COMPLETED: "session_item_completed",
  SESSION_ITEM_TIMEOUT: "session_item_timeout",
  PROCESSING_STEP_STARTED: "processing_step_started",
  PROCESSING_STEP_COMPLETED: "processing_step_completed",
  EVIDENCE_ADDED: "evidence_added",
  AGENT_EVALUATION_COMPLETED: "agent_evaluation_completed",
  UNBOXING_VIDEO_CAPTURED: "unboxing_video_captured",
} as const;

export const ProcessingStepRule = {
  ITEM_RECEIVED: "item_received",
  ITEM_UNDECLARED: "item_undeclared",
} as const;

export const processingStepTypes = [
  "processing_decision",
  "sort",
  "license_plate",
  "evidence",
  "information",
  "verification",
  "verify_item_variant",
  "processing_action",
] as const;

export type ProcessingStepType = (typeof processingStepTypes)[number];

export const ProcessingStepDataType = {
  PROCESSING_DECISION: "processing_decision",
  SORT: "sort",
  LICENSE_PLATE: "license_plate",
  EVIDENCE: "evidence",
  INFORMATION: "information",
  VERIFICATION: "verification",
  VERIFY_ITEM_VARIANT: "verify_item_variant",
  PROCESSING_ACTION: "processing_action",
} as const;

export const ruleOutcomes = [
  "pass",
  "fail",
  "pending",
  "not_applicable",
] as const;

export type RuleOutcome = (typeof ruleOutcomes)[number];

export const RuleOutcome = {
  PASS: "pass",
  FAIL: "fail",
  PENDING: "pending",
  NOT_APPLICABLE: "not_applicable",
} as const;

export const returnsProcessingSessionType = [
  "verification",
  "grading",
  "license_plating",
] as const;

export type ReturnsProcessingSessionType =
  (typeof returnsProcessingSessionType)[number];

export const ReturnsProcessingSessionType = {
  VERIFICATION: "verification",
  GRADING: "grading",
  LICENSE_PLATING: "license_plating",
} as const;
